/* SPECTRAMAG — interacciones propias (prefijo tx-) */
(function () {
  if (window.__txInit) return;
  window.__txInit = true;
  document.documentElement.classList.add('tx-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Titulares palabra a palabra ---------- */
  function splitWords(root) {
    (root || document).querySelectorAll('[data-tx-split]:not([data-split-done])').forEach(function (el) {
      el.setAttribute('data-split-done', '');
      var n = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'tx-w';
              var i = document.createElement('span'); i.textContent = part; i.style.setProperty('--w', n++);
              w.appendChild(i); frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') { walk(child); }
        });
      }
      walk(el);
      el.classList.add('tx-split');
    });
  }

  /* ---------- Observador compartido ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-tx-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }) : null;

  function observe(root) {
    splitWords(root);
    (root || document).querySelectorAll('.tx-reveal, .tx-unveil, .tx-split, [data-tx-count], .tx-step, .tx-vs__table').forEach(function (el) {
      if (el.__txObs) return; el.__txObs = true;
      if (!io || reduce) { el.classList.add('is-in'); if (el.hasAttribute('data-tx-count')) el.textContent = el.getAttribute('data-tx-count'); return; }
      io.observe(el);
    });
    (root || document).querySelectorAll('[data-tx-stagger]').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
    });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-tx-count')) || 0;
    var dec = (el.getAttribute('data-tx-count').split('.')[1] || '').length;
    var t0 = null, dur = 1800;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var v = target * (1 - Math.pow(1 - p, 4));
      el.textContent = v.toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Hero: entrada y parallax con el ratón ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.tx-hero').forEach(function (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-loaded'); });
      var img = hero.querySelector('.tx-hero__media img');
      var amt = parseFloat(hero.getAttribute('data-parallax') || '0');
      if (!img || reduce || !amt || window.matchMedia('(hover: none)').matches) return;
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.setProperty('--px', (-x * amt).toFixed(1) + 'px');
        img.style.setProperty('--py', (-y * amt).toFixed(1) + 'px');
      });
    });
  }

  /* ---------- Tarjetas con brillo que sigue al cursor ---------- */
  document.addEventListener('pointermove', function (e) {
    var c = e.target.closest && e.target.closest('.tx-card');
    if (!c) return;
    var r = c.getBoundingClientRect();
    c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    c.style.setProperty('--my', (e.clientY - r.top) + 'px');
  }, { passive: true });

  /* ---------- Parallax de imágenes dentro de su marco ---------- */
  var parEls = [];
  function initParallax(root) {
    (root || document).querySelectorAll('[data-tx-par]').forEach(function (el) { if (parEls.indexOf(el) < 0) parEls.push(el); });
  }
  var ticking = false;
  function onScroll() {
    if (ticking || reduce) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parEls.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        el.style.setProperty('--par', (p * -40).toFixed(1) + 'px');
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Acordeones con altura animada ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.tx-acc > summary');
    if (!s) return;
    e.preventDefault();
    var d = s.parentElement;
    if (d.open) {
      d.classList.remove('is-open');
      setTimeout(function () { d.open = false; }, reduce ? 0 : 520);
    } else {
      d.open = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.add('is-open'); }); });
    }
  });

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-tx-gal]').forEach(function (g) {
      if (g.__tx) return; g.__tx = true;
      var main = g.querySelector('.tx-gal__main');
      var imgs = g.querySelectorAll('.tx-gal__main img');
      var thumbs = g.querySelectorAll('.tx-gal__thumb');
      var cur = 0;
      function go(i) {
        if (!imgs.length) return;
        cur = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = g.querySelector('[data-prev]'), next = g.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(cur - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(cur + 1); });
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null;
      });
      if (window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
      }
    });
  }

  /* ---------- Compra: cantidad, variantes y barra fija ---------- */
  function initBuy(root) {
    (root || document).querySelectorAll('[data-tx-buy]').forEach(function (box) {
      if (box.__tx) return; box.__tx = true;
      var qty = box.querySelector('.tx-qty input');
      box.querySelectorAll('.tx-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qty.value) || 1) + parseInt(b.getAttribute('data-step')));
          qty.value = v;
          box.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = v; });
        });
      });
      var packs = box.querySelector('[data-tx-packs]');
      if (packs) {
        var scope = box.closest('.tx-section') || document;
        packs.addEventListener('change', function (e) {
          var r = e.target.closest('input[type="radio"]');
          if (!r) return;
          packs.querySelectorAll('.tx-pack').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
          scope.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = r.value; });
          if (qty) qty.value = r.value;
          var price = r.closest('.tx-pack').getAttribute('data-price');
          scope.querySelectorAll('.tx-sticky [data-tx-price]').forEach(function (p) { p.textContent = price; });
        });
      }
      var dataEl = box.querySelector('script[data-tx-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var money = box.getAttribute('data-money') || '{{amount}}';
      function fmt(cents) {
        var n = (cents / 100).toFixed(2), parts = n.split('.');
        var ints = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, ints + ',' + parts[1])
                    .replace(/\{\{\s*amount\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1])
                    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, ints);
      }
      box.addEventListener('change', function (e) {
        if (!e.target.closest('.tx-opt')) return;
        var sel = [];
        box.querySelectorAll('.tx-opt').forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        var btns = document.querySelectorAll('[data-tx-atc]');
        document.querySelectorAll('input[name="id"][data-tx-id]').forEach(function (i) { if (v) i.value = v.id; });
        document.querySelectorAll('[data-tx-price]').forEach(function (p) { if (v) p.textContent = fmt(v.price); });
        document.querySelectorAll('[data-tx-compare]').forEach(function (p) {
          p.textContent = v && v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
        });
        btns.forEach(function (b) {
          var span = b.querySelector('span');
          if (!v) { b.setAttribute('disabled', ''); span.textContent = b.getAttribute('data-unavailable'); }
          else if (!v.available) { b.setAttribute('disabled', ''); span.textContent = b.getAttribute('data-soldout'); }
          else { b.removeAttribute('disabled'); span.textContent = b.getAttribute('data-label'); }
        });
        if (v && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      });
    });
    var sticky = document.querySelector('.tx-sticky');
    var anchor = document.querySelector('[data-tx-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(anchor);
    }
  }

  function initAll(root) {
    observe(root); initHero(root); initParallax(root); initGallery(root); initBuy(root); onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  /* Editor de Shopify: reinicializar al recargar una sección */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
